import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { concatMap, map, switchMap } from 'rxjs/operators';
import { MemberQuery } from '../../../../account/member/member.query';
import { config } from '../../../config';
import { LCID, locales } from './locales';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class TranslationLoader {
  constructor(private memberQuery: MemberQuery, private http: HttpClient, private translateService: TranslateService) {}

  /**
   * Loads the translation file and updates the service to keep in line with the users clubId and LCID
   * if no user is found then it reverts back to the defaults in the config
   * (ClubId = defaultClubId, LCID = defaultLcid)
   */
  loadTranslations(): Observable<null> {
    return this.memberQuery.userContext$.pipe(
      concatMap((userContext) => {
        let clubId: number;
        let lcid: LCID;
        if (userContext) {
          clubId = +userContext.clubId;
          lcid = +userContext.lcid as LCID;
        } else {
          clubId = config.defaultClubId;
          lcid = +config.defaultLcid as LCID;
        }

        let cultureCode = locales[lcid] ?? config.languages[0];
        return this.http.get<string>(`${config.baseApiUrl}/api/content/?clubId=${clubId}&lcid=${lcid}`).pipe(
          concatMap((translation) => {
            this.translateService.setTranslation(cultureCode, translation);
            this.translateService.use(cultureCode);
            return of(null);
          })
        );
      })
    );
  }

  init(): void{
    
    let cultureCode = config.languages[0];
    let clubId = config.defaultClubId;
    let lcid = +config.defaultLcid as LCID;

    this.memberQuery.userContext$.pipe(
      switchMap((userContext) => {
        this.translateService.resetLang(cultureCode);
        if (userContext) {
          clubId = +userContext.clubId;
          lcid = +userContext.lcid as LCID;
          cultureCode = locales[lcid];
        }
        return this.http.get<string>(`${config.baseApiUrl}/api/content/?clubId=${clubId}&lcid=${lcid}`)
        .pipe(
          map(translations => ({ lang: cultureCode, translations }))
        )
      }),
      takeUntilDestroyed()
    ).subscribe(({ lang, translations }) => {
      this.translateService.setTranslation(lang, translations);
      this.translateService.use(lang);
    });

  }
}
